<template lang="pug" src="./ListUsers.pug">

</template>
<script>

import { mapActions } from 'vuex'
import { buildPayloadPagination } from '@/utils/utils.js'

export default {
  name: 'ListUsers',

  data: () => ({
    search: '',
    dataTableLoading: false,
    expanded: [],
    singleExpand: false,
    pagination: {},
    planOptions: [
      { text: 'básico', value: 1 },
      { text: 'premium', value: 2 },
      { text: 'premium gratuito', value: 4 }
    ],
    dialogPlan: false,
    selectedUserForPlan: null,
    newPlanValue: null,
    selectKey: 0,
  }),

  computed: {
    headers() {
      return [
        { text: 'Criado', value: 'createdAt', cellClass: 'body-2' },
        { text: 'Nome', value: 'name', cellClass: 'body-2' },
        { text: 'E-mail', value: 'email', cellClass: 'body-2' },
        // { text: 'Tipo de Conta', value: 'role', cellClass: 'body-2' },
        { text: 'Plano', value: 'plan', cellClass: 'body-2', width: '200px' },
      ]
    },
    users(){
      return this.$store.state.users.users
    },
    totalUsers(){
      return this.$store.state.users.totalUsers
    }
  },

  methods: {
    ...mapActions(['getUsers', 'updateUser']),

    formatDate(isoString) {
      if (!isoString) return ''
      const date = new Date(isoString)
      return date.toLocaleString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },

    confirmPlanChange(item, planValue) {
      if (item.plan === planValue) return
      this.selectedUserForPlan = item
      this.newPlanValue = planValue
      this.dialogPlan = true
    },

    cancelPlanChange() {
      this.dialogPlan = false
      this.selectedUserForPlan = null
      this.newPlanValue = null
      this.selectKey += 1
    },

    async savePlanChange() {
      if (!this.selectedUserForPlan || !this.newPlanValue) return
      
      try {
        await this.updateUser({
          _id: this.selectedUserForPlan._id,
          plan: this.newPlanValue
        })
        
        this.selectedUserForPlan.plan = this.newPlanValue
        
        this.dialogPlan = false
        this.selectedUserForPlan = null
        this.newPlanValue = null
      } catch (error) {
        console.error(error)
      }
    },

    getPageFromUrl(){
      let url = new URL(location.href)
      let searchParams = new URLSearchParams(url.search)

      if(searchParams.get('page') == null){
        this.pagination.page = 1
        this.pagination.current = 1
      }else{
        this.pagination.page = Number(searchParams.get('page'))
        this.pagination.current = Number(searchParams.get('page'))
        this.pagination.itemsPerPage = Number(searchParams.get('itemsPerPage'))
      }
    },
    async getUsersData(){
      await this.getUsers({ query: '' })
    },
    
    async doSearch(isInitialLoad = false) {
      try {
        this.dataTableLoading = true

        if(this.search.length>0 && isInitialLoad !== true){
          this.pagination.page = 1
          this.pagination.current = 1
        }
        await this.getUsers( buildPayloadPagination(this.pagination, this.buildSearch()) )

        this.dataTableLoading = false

      } catch (error) {
        this.dataTableLoading = false
      }
    },
    buildSearch() {
      window.history.pushState('page', 'Title', `list?page=${this.pagination.page}&itemsPerPage=${this.pagination.itemsPerPage}&key=${this.search}`)
      return this.search
        ? `?key=${this.search}`
        : ''
    }
  },
  mounted(){

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const search = urlParams.get('key')
    if(search){
      this.search = search
    }

    this.getPageFromUrl()

    setTimeout(() => {
      this.doSearch(true)
    }, 200)
  },
  watch: {
    pagination: {
    async handler(newPagination, oldPagination) {
      
      if (JSON.stringify(newPagination) === JSON.stringify(oldPagination)) return
      
      try {
        this.dataTableLoading = true
      
        await this.getUsers(
          buildPayloadPagination(this.pagination, this.buildSearch())
        )

        window.history.pushState('page', 'Title', `list?page=${this.pagination.page}&itemsPerPage=${this.pagination.itemsPerPage}&key=${this.search}`)

        this.dataTableLoading = false
      } catch (error) {
        this.dataTableLoading = false
      }
    },
      deep: true
    },
  }

}
</script>
<style>

  /* CSS corretivo: no Safari Mobile a tabela desconfigurava após expandir algum item */
  tr.v-data-table__expanded__content{
    box-shadow: none !important;
    background-color: #F9F9F9;
  }

  table tbody .v-data-table__mobile-table-row{
    display: block !important;
  }
  div.correctExpandableMobile tr.v-data-table__expanded__content{
    display: block !important;
    width: 100% !important;
  }
  div.correctExpandableMobile tr.v-data-table__expanded__content td{
    display: table;
    width: 100% !important;
  }

</style>
